<template lang="">
  <div>
    <div>
      <GoodTable :rows="files" :columns="columns" />
    </div>
  </div>
</template>
<script>
import Http, { OCR_ENDPOINTS } from "../request";
import GoodTable from "../components/GoodTable.vue";

export default {
  components: {
    GoodTable,
  },

  data() {
    return {
      batchId: null,
      files: [],
      type: null,
      columns: [
        {
          label: "Name",
          field: "name",
        },
        {
          label: "Size",
          field: "size",
          type: "number",
        },
        {
          label: "Type",
          field: "type",
        },
        {
          label: "Progress",
          field: "Progress",
        },
      ],
      images: [],
    };
  },

  created() {
    let data = this.$store.state.imagesData;
    let formData = this.$store.state.formData;
    this.batchId = data["batchId"];
    this.files = data["images"];
    this.type = data["type"];

    console.log(this.files);
  },
  // Http()
  //   .post(OCR_ENDPOINTS.images, formData)
  //   .then((response) => {
  //     let success = response?.data?.images?.length;
  //     let fail = response?.data?.failedImages?.length;
  //     console.log(success);
  //     console.log(fail);
  //     if (success) {
  //       this.$toast.success(`${success} Image(s) added`);
  //     }
  //     if (fail) {
  //       this.$toast.error(`${fail} Image(s) failed`);
  //     }
  //   })
  //   .catch((error) => {
  //     this.$toast.error(error.response.data);
  //   })
  //   .finally(() => {
  //     this.$emit("close");
  //   });
};
</script>
<style lang=""></style>
